<template>
    <div>

        <!-- Table -->

        <enac-custom-files-table :id="id" :endpoint="endpoint" :bus="bus"
            :editing="contextId" :learning-unit-id="learningUnitId">
        </enac-custom-files-table>

        <!-- Creation button -->

        <div class="text-center mt-3" v-if="contextId">
            <button class="btn btn-round btn-default" @click="newFile">
                {{ lang.polaris.form.add_file }}
            </button>
        </div>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus" :title="lang.polaris.form.add_file">
            <enac-custom-files-form :id="id" :bus="bus" :endpoint="endpoint">
            </enac-custom-files-form>
        </trax-ui-modal-default>

        <!-- Deletion confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.file_deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_file_q }}
        </trax-ui-modal-confirm>

        <!-- Local toastr -->

        <trax-ui-toastr :id="id+'-toastr'" passed-label="1" :bus="bus">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-custom-files' },
            learningUnitId: null,
            contextId: null,
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/learning-units/"+this.learningUnitId+"/files",
                bus: new Vue()
            }
        },

        methods: {
            
            newFile: function() {
                this.bus.$emit(this.id+'-edit-open');
            }
        }
    }
</script>
